import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        title: '太陽光電'
      },
      component: () => import('./views/Index.vue')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/main/:id',
      name: 'Main',
      meta: {
        title: '太陽光電'
      },
      component: () => import('./views/Main.vue')
    },
    {
      path: '/month/:id',
      name: 'BarMonth',
      meta: {
        title: '太陽光電-日直條圖'
      },
      component: () => import('./views/Month.vue')
    },
    {
      path: '/year/:id',
      name: 'BarYear',
      meta: {
        title: '太陽光電-月直條圖'
      },
      component: () => import('./views/Year.vue')
    },
    {
      path: '/interval/:id',
      name: 'Interval',
      meta: {
        title: '太陽光電-區間度數查詢'
      },
      component: () => import('./views/Interval.vue')
    },
    {
      path: '/total',
      name: 'Total',
      meta: {
        title: '太陽光電-案場資訊查詢'
      },
      component: () => import('./views/Total.vue')
    },
    {
      path: '*',
      component: () => import('./views/NotFound.vue')
    },
    {
      path: '/main/ie/:id',
      name: 'MainIE',
      meta: {
        title: '太陽光電'
      },
      component: () => import('./views/MainIE.vue')
    },
    {
      path: '/main/pic/:id',
      name: 'MainPic',
      meta: {
        title: '太陽光電'
      },
      component: () => import('./views/MainPic.vue')
    },
    {
      path: '/mix/:id',
      name: 'Mix',
      meta: {
        title: '太陽光電'
      },
      component: () => import('./views/Mix.vue')
    },
  ]
})

// title
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title;
  next()
})

export default router